import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Federation, Licence } from 'app/shared/models/class/federation/federation';
import { FederationsService } from 'app/shared/services/federations/federations.service';
import { UiService } from 'app/shared/services/ui/ui.service';

export interface DialogData {
  action: string;
  federation: Federation;
  licence: Licence;
}

type switchOptions = {
  [key: string]: any
};

@Component({
  selector: 'app-open-dialog-add-edit-licence',
  templateUrl: './open-dialog-add-edit-licence.component.html',
  styleUrls: ['./open-dialog-add-edit-licence.component.scss']
})
export class OpenDialogAddEditLicenceComponent implements OnInit {
  licenceForm: UntypedFormGroup;
  title: string;
  btnConfirm: string;
  text: string;
  licence: Licence;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpenDialogAddEditLicenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private federationsSrv: FederationsService,
    private uiService: UiService
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  onSubmit(): void {


    switch (this.data.action) {
      case 'add':
        let licence = new Licence(
          this.data.federation.federationKey,
          this.f.label.value,
          this.f.description.value,
          this.f.price.value
        );
        this.federationsSrv.addLicence(licence).subscribe({
          next: () => {
            this.uiService.showSnackbar('Licence créée avec succès');
            this.dialogRef.close(true)
          }
        });

        break;
      case 'edit':
        this.licence = this.data.licence;
        this.licence.label = this.f.label.value;
        this.licence.description = this.f.description.value;
        this.licence.price = this.f.price.value;

          this.federationsSrv.updateLicence(this.licence).subscribe({
            next: () => {
              this.uiService.showSnackbar('Licence modifiée avec succès');
              this.dialogRef.close(true)
            }
          });


        break;

      default:
        break;
    }
  }

  private getLabel(type: string): string {
    const label: switchOptions = {
      add: {
        title: 'Ajouter une licence',
        confirm: 'Ajouter',
        text: 'Licence ajoutée'
      },
      edit: {
        title: 'Modifier la licence',
        confirm: 'Mettre à jour',
        text: 'Licence mise à jour',
      },
    };
    return label[this.data.action][type];
  }

  private initComponent(): void {

    this.title = this.getLabel('title');
    this.btnConfirm = this.getLabel('confirm');
    this.text = this.getLabel('text');
  }

  get f() {
    return this.licenceForm.controls;
  }

  private initForm(): void {
    let label = '';
    let description = '';
    let price = null;
    if (this.data.licence) {
      label = this.data.licence.label;
      description = this.data.licence.description;
      price = this.data.licence.price;
    }
    this.licenceForm = this.formBuilder.group({
      label: [label, Validators.required],
      description: [description],
      price: [price, [Validators.required, Validators.min(1)]],
    });
  }
}
